// Standalone landing-page composition. Mirrors src/pages/Home.tsx but lives
// outside the SPA src tree so the standalone Vite build owns the entry point.
// All home subcomponents are imported from the SPA source — single source of
// truth, no duplication.

import HomeNav from "@/components/home/HomeNav";
import HomeHero from "@/components/home/HomeHero";
import HomeConcept from "@/components/home/HomeConcept";
import HomeMarketecture from "@/components/home/HomeMarketecture";
import HomeTemplates from "@/components/home/HomeTemplates";
import HomeAgentsMd from "@/components/home/HomeAgentsMd";
import HomeCTA from "@/components/home/HomeCTA";
import HomeFooter from "@/components/home/HomeFooter";

export default function HomeLanding() {
  return (
    <div className="min-h-full w-full bg-canvas text-ink">
      <HomeNav />
      <HomeHero />
      <HomeConcept />
      <HomeMarketecture />
      <HomeTemplates />
      <HomeAgentsMd />
      <HomeCTA />
      <HomeFooter />
    </div>
  );
}
